import { useMediaQuery } from '@mui/material';
import * as moment from 'moment';
import { useTheme } from 'styled-components';
import { useComponentStyleContext } from '../../component-style-context';
import { NewsListItemModel } from '../../NewsList/contracts';
import { useDynamicListCarouselContext } from '../dynamic-lists-carousel/dynamic-list-context';
import {
	DateText,
	Description,
	DynamicCard,
	DynamicCardImage,
	DynamicCardLink,
	DynamicCardMain,
	DynamicCardWrapper,
	Title
} from '../dynamic-lists-carousel/shared';

export interface DynamicNewsCardProps {
	id: number;
	newsItem: NewsListItemModel;
	hideThumbnail?: boolean;
	hideReadMore?: boolean;
}

export function DynamicNewsCard({ newsItem, hideThumbnail, id, hideReadMore }: DynamicNewsCardProps) {
	const theme = useTheme();
	const { positions, carouselState } = useDynamicListCarouselContext();
	const { headerFont, headerFontColour, font, fontColour } = useComponentStyleContext();
	const isMobile = useMediaQuery('(max-width: 800px)'); //all instances of useMediaQuery will be replaced once the SwiftFox useDeviceType hook is merged in
	if (!newsItem) return <></>;
	const cardPosition = positions.find(p => p.id === id)?.position;
	const date = newsItem.publishDateFormatted ?? moment(newsItem.publishDate).format('DD MMM YYYY');
	const disable = carouselState.fullyObscuredItems.includes(id);

	return (
		<DynamicCardWrapper position={cardPosition}>
			<DynamicCardLink href={newsItem.link} target={'_blank'} style={{ pointerEvents: disable && !isMobile ? 'none' : 'initial' }}>
				<DynamicCard>
					{!hideThumbnail ? <DynamicCardImage src={newsItem.mobileThumbnailUrl || newsItem.thumbnailUrl} /> : null}
					<DynamicCardMain>
						<DateText style={{ ...font }}>
							{date && newsItem.publishDateFormatted ? date : null}
							{date && newsItem.publishDateFormatted && newsItem.tags?.length ? <> | </> : null}
							{newsItem.tags?.map((tag, i) => {
								return (
									<span
										key={i}
										style={{
											color: theme.palette.primary.main,
											fontWeight: 'bold'
										}}
									>{`${tag}${i < newsItem.tags.length - 1 ? ', ' : ''}`}</span>
								);
							})}
							<span style={{ opacity: 0 }}>-</span>
						</DateText>
						<Title style={{ ...headerFont, ...headerFontColour }} variant="h4" $numberOfLines={hideReadMore ? 4 : 2}>
							{newsItem.title}
						</Title>
						{!hideReadMore ? (
							<Description style={{ ...font, ...fontColour }}>
								{newsItem.readMoreSummary || newsItem.summary || ''}
							</Description>
						) : null}
					</DynamicCardMain>
				</DynamicCard>
			</DynamicCardLink>
		</DynamicCardWrapper>
	);
}
